import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]

  connect() {
    this.mediaQuery = window.matchMedia("(min-width: 768px)")
    const hasLeftClass = this.menuTarget.classList.contains("-translate-x-full")
    const hasRightClass = this.menuTarget.classList.contains("translate-x-full")
    this.hiddenClass = hasLeftClass ? "-translate-x-full" : hasRightClass ? "translate-x-full" : "-translate-x-full"

    this.escapeListener = (ev) => {
      if (ev.key !== "Escape") return
      if (this.menuTarget.classList.contains(this.hiddenClass)) return
      this.close()
    }
    this.toggleListener = () => {
      this.toggle()
    }
    this.openListener = () => {
      this.open()
    }
    this.resizeListener = () => {
      // Native apps always use the drawer; do not treat wide WebViews as desktop.
      const isNative = document.documentElement.dataset.hotwireNative === "true"
      if (this.mediaQuery.matches && !isNative) {
        this.forceClose()
      }
    }
    window.addEventListener("keydown", this.escapeListener)
    window.addEventListener("side-menu:toggle", this.toggleListener)
    window.addEventListener("side-menu:open", this.openListener)
    this.mediaQuery.addEventListener("change", this.resizeListener)
  }

  disconnect() {
    window.removeEventListener("keydown", this.escapeListener)
    window.removeEventListener("side-menu:toggle", this.toggleListener)
    window.removeEventListener("side-menu:open", this.openListener)
    this.mediaQuery.removeEventListener("change", this.resizeListener)
  }

  open() {
    this.menuTarget.classList.remove(this.hiddenClass)
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.forceClose()
  }

  forceClose() {
    this.menuTarget.classList.add(this.hiddenClass)
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  toggle() {
    if (this.menuTarget.classList.contains(this.hiddenClass)) {
      this.open()
    } else {
      this.close()
    }
  }
}
